import React, { memo } from 'react'

export interface Props {
  languagePrefix?: string
}

export const Iubenda = memo(function Iubenda({ languagePrefix }: Props) {
  if (!process.env.IUBENDA_COOKIE_ID || !process.env.IUBENDA_COOKIE_ID_EN) {
    return null
  }

  return (
    <>
      <script type="text/javascript">
        {` var _iub = _iub || [];
          _iub.csConfiguration = {
            "askConsentAtCookiePolicyUpdate": true,
            "countryDetection": true,
            "enableFadp": true,
            "enableLgpd": true,
            "enableUspr": true,
            "floatingPreferencesButtonDisplay": "bottom-left",
            "lgpdAppliesGlobally": false,
            "perPurposeConsent": true,
            "floatingPreferencesButtonZIndex": 10,
            "siteId": ${process.env.IUBENDA_SITE_ID},
            "cookiePolicyId": ${
              languagePrefix === 'en'
                ? process.env.IUBENDA_COOKIE_ID_EN
                : process.env.IUBENDA_COOKIE_ID
            },
            "lang": "${languagePrefix}",
            "banner": { 
              "acceptButtonCaptionColor": "#434343",
              "acceptButtonColor": "#FFFFFF",
              "acceptButtonDisplay": true,
              "backgroundColor": "#434343",
              "closeButtonDisplay": false,
              "customizeButtonCaptionColor": "#434343",
              "customizeButtonColor": "#C7C7C7",
              "customizeButtonDisplay": true,
              "explicitWithdrawal": true,
              "listPurposes": true,
              "position": "bottom",
              "rejectButtonCaptionColor": "#434343",
              "rejectButtonColor": "#FFFFFF",
              "rejectButtonDisplay": true 
            }
          };
        `}
      </script>

      <script
        type="text/javascript"
        src={`https://cs.iubenda.com/autoblocking/${process.env.IUBENDA_SITE_ID}.js`}
      />
      <script type="text/javascript" src="//cdn.iubenda.com/cs/gpp/stub.js" />
      <script
        type="text/javascript"
        src="//cdn.iubenda.com/cs/iubenda_cs.js"
        async
      />
    </>
  )
})
